import { useEffect, useState, useRef } from "react";
import PrimarySearchAppBar from "../../components/navBar/navBar";
import { set } from "date-fns";
import useCurrency from "../../hooks/useCurrency";


const EventBookingSummaryV2 = () => {
  const [selectedEvent, setSelectedEvent] = useState();
  const [storeChoosenTickets, setStoreChoosenTickets] = useState([]);
  const [storeChoosenSeats, setStoreChoosenSeats] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const formRef = useRef();
  const proceedRef = useRef();
  const { convert } = useCurrency();

  useEffect(() => {
    const eventName = localStorage.eventName;
    const eventVenue = localStorage.eventVenue;
    const eventDate = localStorage.selectedDateOfTheEvent;
    const eventTime = localStorage.selectedTimeOfTheEvent;
    const evdt_Id = parseInt(localStorage.evdt_id);
    const totalAmount = parseInt(localStorage.getItem("totalAmount"));

    setSelectedEvent([eventName, eventVenue, eventDate, eventTime, evdt_Id]);
    setTotalAmount(totalAmount);
  }, []);

  useEffect(() => {
    const storedChoosenTicketsString = localStorage.getItem("choosenTickets");
    const storedChoosenTickets = storedChoosenTicketsString
      ? JSON.parse(storedChoosenTicketsString)
      : [];

    console.log(storedChoosenTickets);


    const storedChoosenSeatsString = localStorage.getItem("seats");
    const storedChoosenSeats = storedChoosenSeatsString
      ? JSON.parse(storedChoosenSeatsString)
      : [];
    
    setStoreChoosenSeats(storedChoosenSeats);  
    setStoreChoosenTickets(storedChoosenTickets);
  }, []);

  const totalQuantityOfTickets = storeChoosenTickets.reduce(
    (acc, ticket) => acc + ticket.quantity,
    0
  );

  const totalAmountOfTickets = storeChoosenTickets.reduce(
    (acc, ticket) => acc + ticket.price * ticket.quantity,
    0
  );

  console.log(totalAmountOfTickets, totalQuantityOfTickets);

  function pushDataToServer(event) {
    event.preventDefault();

    const form = new FormData(formRef.current);

    const payload = {
      evdt_id: selectedEvent[4],
      user: {
        email: form.get("email"),
        mobile: form.get("mobile"),
        firstName: form.get("firstName"),
        lastName: form.get("lastName"),
      },
      basket:{
        tickets:totalQuantityOfTickets,
        discount: 0,
        promotions: 0,
        fees: 0,
        total: totalAmountOfTickets

      },

      tickets: storeChoosenTickets,
    };

    // console.log(user_and_Ticket_Data);

    const url = `${process.env.REACT_APP_DEV_BASE_URL}/event/${selectedEvent[4]}/book`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Response data:", data);
        proceedRef.current.textContent = "Success";

        setTimeout(() => {
          proceedRef.current.textContent = "Proceed";
        }, 1500);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  function toggleFormView() {
    formRef.current.classList.toggle("view");
  }



  return (
    <>
      {/* <PrimarySearchAppBar /> */}
      <div className="wrapper">
        <div className="spacer"></div>
        <h1 className="textCenter spacer  pageTitle heading_underline">Booking Summary</h1>

        <div className="summaryDetails ">
          {selectedEvent ? (
            <p className="booked_eventName">Event - {selectedEvent[0]}</p>
          ) : (
            <p className="booked_eventName">Event - Not Available</p>
          )}

          {selectedEvent ? (
            <p className="booked_eventVenue">Venue - {selectedEvent[1]}</p>
          ) : (
            <p className="booked_eventVenue">Venue - Not Available</p>
          )}

          {selectedEvent ? (
            <p className="booked_eventDate">Date - {selectedEvent[2]}</p>
          ) : (
            <p className="booked_eventDate">Date - Not Available</p>
          )}

          {selectedEvent ? (
            <p className="booked_eventTime">Time - {selectedEvent[3]}</p>
          ) : (
            <p className="booked_eventTime">Time - Not Available</p>
          )}
        </div>

        <div className="ticketType">
          {storeChoosenTickets.map((ticket) => (
            <div className="ticketDetails_Price flexB">
              <div className="ticket_category">{ticket.category}</div>
              <div className="ticketQuantity">{ticket.quantity} Qty</div>

              <div className="ticketAmount">
                {convert(ticket.amount)}
              </div>
            </div>
          ))}

          {storeChoosenSeats?.map((seat)=>(
            <div className="ticketDetails_Price flexB">
            <div className="ticket_category">{seat.type}</div>
            <div className="ticketQuantity">{seat.adultCount} Qty</div>
            <div>{seat.seatNumbers}</div>

            <div className="ticketAmount">
              {convert(seat.amount)}
            </div>
          </div>
          )

          )}
        </div>

        <div className="amountPayable">
          <div className="totalAmount flexB">
            <div className="totalAmountLable">
              <b>Ticket Price -</b>
            </div>
            <div className="amount">{convert(totalAmount)}</div>
          </div>

          <div className="handlingPrice flexB">
            <div className="handlingPrice">Handling Price-</div>
            <div className="amount">0</div>
          </div>
        </div>

        <button className="confirm" onClick={toggleFormView}>
          Confirm
        </button>
        <form
          ref={formRef}
          onSubmit={pushDataToServer}
          className="verifyConfirmation_Modal "
        >
          <h5>Verify Confirmation</h5>
          <div className="flexB">
            <label htmlFor="firstName">First Name</label>
            <input type="text" name="firstName" id="firstName" required />
          </div>
          <div className="flexB">
            <label htmlFor="lastName">Last Name</label>
            <input
              type="text"
              name="lastName"
              id="lastName"
              placeholder="optional"
            />
          </div>
          <div className="flexB">
            <label htmlFor="mobile">Mobile</label>
            <input type="number" name="mobile" id="mobile" required />
          </div>

          <div className="flexB">
            <label htmlFor="email">Email</label>
            <input type="email" name="email" id="email" required />
          </div>

          <button ref={proceedRef} type="submit " className="proceedBtn">
            Proceed
          </button>
        </form>
        <div className="overlay" onClick={toggleFormView}></div>
      </div>
    </>
  );
};

export default EventBookingSummaryV2;
